import {
  CcfAcdOutboundIcon,
  CcfAvailableIcon,
  CcfBox,
  CcfButton,
  CcfCallOutboundIcon,
  CcfPhoneInboundIcon,
  CcfTypography,
  CcfUnavailableIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from './ccf-performance.module.scss';
import { makeStyles } from '@mui/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { agentPerformance, teamPerformance } from '../reporting-mock-data';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import { Divider } from '@mui/material';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableCell: {
    padding: 10,
    border:'none',
  }
});

addLocale('es', {
  firstDayOfWeek: 1,
  dayNames: [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
  ],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthNamesShort: [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ],
  today: 'Hoy',
  clear: 'Claro',
});

/* eslint-disable-next-line */
export interface CcfPerformanceProps {}
/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
export function CcfPerformance(props: CcfPerformanceProps) {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [clickedButton, setClickedButton] = useState('today');
  const [rows, setRows] = useState([]);
  const [translate] = useTranslator();
  const [overallPerformancePercentage, setOverallPerformancePercentage] =
    useState(0);
  const [dates2, setDates2] = useState<Date | Date[] | undefined>(undefined);
  const [isVisible, setisVisible] = useState(true);
  const classes = useStyles();
  const today = new Date();
  const month = today.getMonth();
  const calendeRef = useRef(null);
  const prevMonth = month === 0 ? 11 : month - 1;
  const minDate = new Date();
  minDate.setMonth(prevMonth);

  useEffect(() => {
    if (clickedButton !== 'custom' && clickedButton !== "") {
      handlePerformanceData(clickedButton);
    }
  }, [clickedButton]);

  useEffect(() => {
    if (Array.isArray(dates2) && dates2[1] !== null) {
      handlePerformanceData('custom');
    }
  }, [dates2]);

  /**
   * used to set up performance data on Filter button click
   * @example - handlePerformanceData()
   */
  const handlePerformanceData = (label: any) => {
    const agentPerformanceData = agentPerformance.filter(
      (item: any) => item.type === clickedButton
    );
    const teamPerformanceData = teamPerformance.filter(
      (item: any) => item.type === clickedButton
    );
    const performanceData: any = [
      {
        id: '1',
        callType: 'inbound',
        selfPerformance: agentPerformanceData[0].inboundHandled,
        teamPerformance: teamPerformanceData[0].inboundHandled,
        performancePercent: Math.round(
          (parseInt(agentPerformanceData[0].inboundHandled) /
            parseInt(teamPerformanceData[0].inboundHandled)) *
            100
        ),
      },
      {
        id: '2',
        callType: 'outbound',
        selfPerformance: agentPerformanceData[0].outboundHandled,
        teamPerformance: teamPerformanceData[0].outboundHandled,
        performancePercent: Math.round(
          (parseInt(agentPerformanceData[0].outboundHandled) /
            parseInt(teamPerformanceData[0].outboundHandled)) *
            100
        ),
      },
      {
        id: '3',
        callType: 'overall',
        selfPerformance: agentPerformanceData[0].totalHandled,
        teamPerformance: teamPerformanceData[0].totalHandled,
        performancePercent: Math.round(
          (parseInt(agentPerformanceData[0].totalHandled) /
            parseInt(teamPerformanceData[0].totalHandled)) *
            100
        ),
      },
    ];
    setOverallPerformancePercentage(
      Math.round(
        (parseInt(agentPerformanceData[0].totalHandled) /
          parseInt(teamPerformanceData[0].totalHandled)) *
          100
      )
    );
    setRows(performanceData);
  };

  /**
   * used to handle filter button clicks
   * @example - handleFilterButtonclick()
   */
  const handleFilterButtonclick = (btnLabel: string) => {
    if (btnLabel === 'custom' || clickedButton !== btnLabel) {
      setClickedButton(btnLabel);
      if (btnLabel !== 'custom') {
        setShowDatePicker(false);
      }
    } else {
      setClickedButton('');
    }
  };

  /**
   * used to handle Custom Button Click
   * @example - handleCustomButtonclick()
   */
  const handleCustomButtonclick = (e: any) => {
    if (clickedButton !== e.target.value) {
      setClickedButton(e.target.value);
    } else {
      setClickedButton('');
    }
    setClickedButton((state: any) => {
      return state;
    });
    setDates2(undefined);
    setShowDatePicker(!showDatePicker);
  };
  /**
   * used to render icon for performance
   * @example - renderIcon()
   */
  function renderIcon(iconCode: string) {
    switch (iconCode) {
      case '1':
        return (
          <CcfPhoneInboundIcon
            style={{ fill: '#007AB8', fontSize: '16px', marginTop: '10px' }}
          />
        );
      case '2':
        return (
          <CcfCallOutboundIcon
            style={{ fill: '#007AB8', fontSize: '16px', marginTop: '10px' }}
          />
        );
      default:
        return '';
    }
  }

  return (
    <CcfBox className={styles.productivityContainer}>
      <section
        className={
          showDatePicker
            ? styles.productivityHeader
            : styles.productivityHeaderWithMargin
        }
      >
        <CcfTypography className={styles.tabValue} >
          {translate('performance')} ({overallPerformancePercentage}%)
        </CcfTypography>
        <div>
          <CcfButton
            className={
              clickedButton !== 'today' ? styles.activeBtn : styles.defaultBtn
            }
            variant="outlined"
            value="today"
            onClick={() => handleFilterButtonclick('today')}
          >
            {translate('today')}
          </CcfButton>
          <CcfButton
            className={
              clickedButton !== 'yesterday'
                ? styles.activeBtn
                : styles.defaultBtn
            }
            variant="outlined"
            value="yesterday"
            onClick={() => handleFilterButtonclick('yesterday')}
          >
            {translate('yesterday')}
          </CcfButton>
          <CcfButton
            className={
              clickedButton !== 'last7days'
                ? styles.activeBtn
                : styles.defaultBtn
            }
            variant="outlined"
            value="last7days"
            onClick={() => handleFilterButtonclick('last7days')}
          >
             {translate('last7days')}
          </CcfButton>
          <CcfButton
            className={
              clickedButton !== 'custom' ? styles.activeBtn : styles.defaultBtn
            }
            variant="outlined"
            value="custom"
            onClick={(e) => handleCustomButtonclick(e)}
          >
             {translate('custom')}
          </CcfButton>
        </div>
      </section>
      {showDatePicker && (
        <section className={styles.customFilterContainer}>
          <Calendar
            ref={calendeRef}
            visible={isVisible}
            hideOnDateTimeSelect={true}
            showButtonBar
            placeholder={translate("SelectDateRange")}
            id="range"
            showIcon
            minDate={minDate}
            maxDate={today}
            value={dates2}
            onChange={(e : any) => setDates2(e.value)}
            selectionMode="range"
            readOnlyInput
          />
        </section>
      )}
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={styles.tableHeader}>
            <TableRow style={{ background: '#ECF3F8' }}>
              <TableCell
                style={{ width: '10%' }}
                align="left"
                className={styles.tableCell}
              ></TableCell>
              <TableCell style={{ width: '30%' }} className={styles.tableCell}>
                {translate('callType')}
              </TableCell>
              <TableCell align="left" className={styles.tableCell}>
                {translate('you')}
              </TableCell>
              <TableCell align="left" className={styles.tableCell}>
                {translate('team')}
              </TableCell>
              <TableCell align="left" className={styles.tableCell}>
              {'% of '} {translate('team')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {rows.map((row: any, index: number) => (
              <>
                {index === 2 && (
                  <Divider style={{ width: '100%', visibility: 'hidden' }} /> //adding divider to display border top for third row
                )}
                <TableRow
                  key={row?.callType}
                  className={
                    row?.callType === 'Overall' ? styles.overallTableRow : ''
                  }
                >
                  <TableCell
                    align="right"
                    style={{ width: '10%' }}
                    component="th"
                    scope="row"
                    className={classes.tableCell}
                  >
                    {renderIcon(row?.id)}
                  </TableCell>
                  <TableCell
                    style={{
                      width: '30%',
                    }}
                    component="th"
                    scope="row"
                    className={classes.tableCell}
                  >
                    {translate(row?.callType)}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    <CcfTypography style={{ marginLeft: '10px' }}>
                      {row?.selfPerformance}
                    </CcfTypography>
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    <CcfTypography style={{ marginLeft: '10px' }}>
                      {row?.teamPerformance}
                    </CcfTypography>
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    <CcfTypography style={{ marginLeft: '10px' }}>
                      {row?.performancePercent}%
                    </CcfTypography>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CcfBox>
  );
}

export default CcfPerformance;
